import { render, staticRenderFns } from "./AddPersonDialog.vue?vue&type=template&id=3ff3338d"
import script from "./AddPersonDialog.vue?vue&type=script&lang=ts"
export * from "./AddPersonDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports